
import { defineComponent, ref, watch } from '@nuxtjs/composition-api'
import { computed } from '@vue/composition-api'
import TeleportV2 from '~/components/TeleportV2.vue'

export default defineComponent({
  name: 'PopupBase',
  components: { TeleportV2 },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hideBackground: {
      type: Boolean,
      default: false,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isMounted = ref(props.open)
    const openDialog = ref(props.open)
    const isOpen = computed(() => props.open)

    const onClose = () => {
      openDialog.value = false
      emit('close')
    }
    const onSwipeBottom = (e) => {
      if (e.deltaY > 0) {
        isMounted.value = false
      }
    }

    watch(
      () => props.open,
      () => {
        if (process.browser) {
          if (isOpen.value) {
            document.querySelector('html').style.overflowY = 'hidden'
          } else {
            document.querySelector('html').style.overflowY = 'auto'
          }
        }
        if (isOpen.value) {
          openDialog.value = true
          setTimeout(() => {
            isMounted.value = true
          })
        } else {
          setTimeout(() => {
            isMounted.value = false
          })
        }
      }
    )
    return {
      openDialog,
      isMounted,
      onSwipeBottom,
      onClose,
    }
  },
})
